<template>
  <div class="LKPublicationsCardList">
    <template v-for="item in list">
      <LKPublicationsCard
        :key="item.id"
        :data="item"
        :get-publication="getPublication"
        :topic-slug="topicSlug"
        class="LKPublicationsCardList__item"
        v-on="$listeners"
      />
    </template>

    <div class="LKPublicationsCardList__button-container">
      <LKProgressCircular
        v-if="loading"
        :size="50"
      />

      <v-btn
        v-else-if="canGetData"
        v-observe-visibility="observeVisibility"
        :color="color"
        dense
        depressed
        dark
        @click="onGetNextPage"
        v-text="'Загрузить еще'"
      />
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility'
import variables from '@/assets/scss/exports.scss'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKPublicationsCard from './LKPublicationsCard/LKPublicationsCard.vue'


export default {
  name: 'LKPublicationsCardList',
  components: {
    LKProgressCircular,
    LKPublicationsCard,
  },
  directives: {
    ObserveVisibility,
  },
  props: {
    loading: Boolean,
    list: {
      type: Array,
      default: () => [],
    },
    getPublication: {
      type: Function,
      reuired: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    topicSlug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    color: variables['webflow-color-blue'],
  }),
  computed: {
    canGetData() {
      const { count, per_page, page } = this.pagination
      return count > page * per_page
    },
    observeVisibility() {
      return {
        callback: this.onVisibilityChange,
        throttle: 300,
        throttleOptions: {
          leading: 'visible',
        },
      }
    },
  },
  methods: {
    onGetNextPage() {
      this.$emit('change:next-page')
    },
    onVisibilityChange(isVisible) {
      if (!isVisible) return
      if (this.loading) return
      this.onGetNextPage()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsCardList {
  &__item {
    margin-bottom: 20px;
  }

  &__button-container {
    display: flex;
    justify-content: center;
  }
}
</style>
